var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-sidebar flex-grow-1",attrs:{"data-v-sticky-container":""}},[_c('aside',{directives:[{name:"sticky",rawName:"v-sticky",value:(_vm.option),expression:"option"}],staticClass:"sidebar"},[_c('div',{staticClass:"sidebar-inner-container",attrs:{"data-v-sticky-inner":""}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }